/* ===================================================================
   UAS Reviews - endless loop for the Google review carousels.

   sections/uas-reviews.liquid renders a native scroll-snap carousel.
   Its own arrows wrapped by rewinding the whole strip back to 0, and a
   swipe or drag did not wrap at all - it just stopped dead on the last
   card. That hard stop is what shows on mobile, where the arrows are
   hidden and swiping is the only control.

   This makes the strip endless instead. The track is tripled --
   [clones][originals][clones] -- so it is periodic with period setW
   (one full set including its trailing gap). We park on the middle
   set and, once scrolling has SETTLED, teleport by exactly one period
   whenever the position drifts out of the middle band. The pixels one
   period away are identical, so the jump cannot be seen; the carousel
   simply never reaches an end, by swipe, drag, arrow or autoplay.

   Deferred on purpose:
   - teleporting mid-flick cancels iOS momentum, so the jump waits
     110ms after the last scroll event and never runs while a finger
     or button is down (holding).
   - scroll-behavior:smooth and scroll-snap-type are suspended via
     INLINE styles for the jump frame (the section's rules are not
     !important, so inline wins) or the browser animates the teleport
     and it becomes a visible rewind.

   No change is needed in the section: with the position held mid-strip
   its atEnd() / scrollLeft<=4 rewind branches can no longer fire, so
   its arrows and autoplay fall through to plain scrollBy and inherit
   the loop. Loaded globally from snippets/uas-menu-toggle.liquid.
   =================================================================== */
(function () {
  function setup(el) {
    var vp = el.querySelector('[data-uasr-viewport]');
    if (!vp) return;
    var track = vp.querySelector('.uasr-track');
    if (!track || track.getAttribute('data-uasr-loop')) return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) return;
    if (track.scrollWidth <= vp.clientWidth + 4) return; /* nothing to scroll */

    function copies() {
      var f = document.createDocumentFragment();
      originals.forEach(function (c) {
        var d = c.cloneNode(true);
        d.setAttribute('aria-hidden', 'true');
        d.setAttribute('data-uasr-clone', '');
        d.removeAttribute('id');
        Array.prototype.slice.call(d.attributes).forEach(function (a) {
          if (a.name.indexOf('data-shopify') === 0) d.removeAttribute(a.name);
        });
        f.appendChild(d);
      });
      return f;
    }

    track.insertBefore(copies(), originals[0]);
    track.appendChild(copies());
    track.setAttribute('data-uasr-loop', String(originals.length));

    var setW = 0, holding = false, settle = null, rz = null;

    function measure() {
      var k = track.children;
      setW = (k[0] && k[originals.length]) ? k[originals.length].offsetLeft - k[0].offsetLeft : 0;
    }
    function jump(x) {
      var sb = vp.style.scrollBehavior, ss = vp.style.scrollSnapType;
      vp.style.scrollBehavior = 'auto';
      vp.style.scrollSnapType = 'none';
      vp.scrollLeft = x;
      requestAnimationFrame(function () {
        vp.style.scrollBehavior = sb;
        vp.style.scrollSnapType = ss;
      });
    }
    function normalize() {
      if (!setW) return;
      var x = vp.scrollLeft, y = x;
      while (y < setW * 0.5) { y += setW; }
      while (y > setW * 1.5) { y -= setW; }
      if (y !== x) jump(y);
    }
    function settled() {
      if (settle) clearTimeout(settle);
      settle = setTimeout(function () { if (!holding) normalize(); }, 110);
    }

    measure();
    if (!setW) return;
    jump(setW);

    vp.addEventListener('scroll', settled, { passive: true });
    ['touchstart', 'pointerdown'].forEach(function (t) {
      vp.addEventListener(t, function () { holding = true; }, { passive: true });
    });
    ['touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (t) {
      vp.addEventListener(t, function () { holding = false; settled(); }, { passive: true });
    });
    window.addEventListener('resize', function () {
      if (rz) clearTimeout(rz);
      rz = setTimeout(function () { measure(); normalize(); }, 160);
    });
  }

  function run(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.uas-reviews').forEach(setup);
    if (scope !== document && scope.classList && scope.classList.contains('uas-reviews')) setup(scope);
  }

  function boot() { run(document); setTimeout(function () { run(document); }, 500); }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
